import * as React from 'react';
import { VacationDetailsDialogModel } from '../CalendarModel';
import { CalendarController as CalendarController } from '../CalendarController';
import { Dialog } from 'components/dialog';
import { Button } from '@material-ui/core';
import { th } from 'date-fns/esm/locale';

export class VacationDetailsDialog extends React.Component<Props, State> {

    private constructor(props: Props) {
        super(props);

        this.onDeleteClicked = this.onDeleteClicked.bind(this);
        this.onCloseClicked = this.onCloseClicked.bind(this);
    }

    private onDeleteClicked() {
        this.props.controller.deleteVacation(this.props.model.id);
    }

    private onCloseClicked() {
        this.props.controller.hideDetailsDialog();
    }

    public render() {
        if (this.props.model == null) {
            return (<></>);
        }

        var title = this.props.model.type;
        if (this.props.model.halfDayType != null) {
            title = "Half day " + title;
        }

        var desc = this.props.model.startDate;
        if (this.props.model.halfDayType != null) {
            desc = (this.props.model.halfDayType == "FirstHalf" ? "First half of " : "Second half of ") + desc;
        } else {
            desc += " - " + this.props.model.endDate;
        }

        return (
            <Dialog title={title} desc={desc} error={this.props.model.globalError}>
                <div>
                    {this.props.model.description}
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%', marginTop: '32px' }}>
                    {this.props.model.isDeleteVisible && (
                        <Button color="secondary" onClick={this.onDeleteClicked}>Delete</Button>
                    )}
                    <Button style={{ marginLeft: '8px' }} color="primary" variant="contained" onClick={this.onCloseClicked}>Close</Button>
                </div>
            </Dialog>
        )
    }

}

export interface Props {

    model: VacationDetailsDialogModel;
    controller: CalendarController;

}

interface State {

}